module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view projects-timeline"
  }, [_c('box', {
    attrs: {
      "label": "New calendar"
    }
  }, [_c('full-calendar', {
    attrs: {
      "config": _vm.calendarConfig
    }
  })], 1), _vm._v(" "), _c('timeline', {
    attrs: {
      "title": "Old Timeline",
      "entries": _vm.timeline_row_entries,
      "show-sidebar": _vm.show_sidebar,
      "sidebar-width": _vm.sidebarWidth
    },
    on: {
      "entry-click": _vm.onEntryclick
    }
  }), _vm._v(" "), (_vm.globals.show_beta_content) ? [_c('br'), _c('br'), _vm._v(" "), _c('box', [_vm._v("\n    BETA: "), _c('br'), _vm._v("\n    - toggle select mellem: done bar vis procent done / time spent / projekt booked pct\n    - book input on click empty input?\n    - "), _c('br'), _vm._v("\n    - timeline skal gøres til et component som tager show_left_col true/false og :row_entries som er et object med rows og subrows, så kan det nemlig bruges på single project såvel som multiple projects skærm\n      - timebooking  from_date  to_date daily_hrs  project_key"), _c('br'), _vm._v("\n    - timelogger: if date within timebooking create default timelog suggestion"), _c('br'), _vm._v("\n    - start screen: show timebookings today "), _c('br'), _vm._v("\n    - timeline: show actual tracked hours (weight per day) on person and project total\n    - timeline show remaining daily hrs booked on person and project total\n    - timeline under project, expandable show persons\n    - timeline under project, expandable show workload hrs\n    - filter persons/all\n    ")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-153cac84","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Projects_timeline.vue
// module id = 583
// module chunks = 1